var map = {
	"./button-hover.png": 5,
	"./button-hover@2x.png": 6
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 114;


//////////////////
// WEBPACK FOOTER
// ./themes/fq/img ^\.\/button\-hover.*\.png$
// module id = 114
// module chunks = d-game